import MinhaConta from '../pages/Inicio/MinhaConta/Menu'
import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Menu'
import Usuarios from '../pages/Admin/Usuarios/Menu'
import LinhaDoTempo from '../pages/Site/LinhaDoTempo/Menu'
import Gestoes from '../pages/Site/Gestoes/Menu'
import Multimidias from '../pages/Site/Multimidias/Menu'
import Noticias from '../pages/Site/Noticias/Menu'
import Paginas from '../pages/Site/Paginas/Menu'
import Portfolio from '../pages/Site/Portfolio/Menu'
import GovernancaEGestao from '../pages/Site/GovernancaEGestao/Menu'

const MenuDefault = [{
	titulo: 'Início',
	icone: 'menu-icon fa fa-tachometer',
	action: false,
	visualizar: false,
	submenu: [...MinhaConta]
},
{
	titulo: 'Site',
	icone: 'menu-icon fa fa-desktop',
	action: false,
	visualizar: false,
	submenu: [ ...Gestoes, ...GovernancaEGestao, ...LinhaDoTempo, ...Multimidias, ...Noticias,  ...Paginas, ...Portfolio]
},
{
	titulo: 'Admin',
	icone: 'menu-icon fa fa-cog',
	action: false,
	visualizar: false,
	submenu: [...GrupoDeAcesso, ...Usuarios,]
}]

export default MenuDefault
